/*
 * 基础方向
 */
export enum Orient {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}

/**
 * 移动的趋势方向
 * 因为 MODES 实际含义是 “控制点”，与移动趋势方向的概念不一致
 * 在 resize的时候，可以通过控制点映射到 direction。但是在 move的时候，就需要自行判定趋势方向
 */
export enum MovementDirection {
    LEFT = 'left',
    RIGHT = 'right',
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT_TOP = 'left-top',
    LEFT_BOTTOM = 'left-bottom',
    RIGHT_TOP = 'right-top',
    RIGHT_BOTTOM = 'right-bottom',
    NONE = 'none',
}

/**
 * 基础的朝向，不包含斜角
 */
export enum OrientDirection {
    LEFT = 'left',
    RIGHT = 'right',
    TOP = 'top',
    BOTTOM = 'bottom',
}

/**
 * 四边的种类
 */
export enum EdgeType {
    LEFT = 'left',
    RIGHT = 'right',
    TOP = 'top',
    BOTTOM = 'bottom',
}

export enum OperationAnchor {
    LEFT = 'left',
    RIGHT = 'right',
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT_TOP = 'left-top',
    LEFT_BOTTOM = 'left-bottom',
    RIGHT_TOP = 'right-top',
    RIGHT_BOTTOM = 'right-bottom',
    ALL = 'all',
}

export type CornerAnchor = OperationAnchor.LEFT_TOP |
    OperationAnchor.RIGHT_TOP |
    OperationAnchor.RIGHT_BOTTOM |
    OperationAnchor.LEFT_BOTTOM;
